import { useEffect, useState } from "react";

export function useTime(): Date {
  const [time, setTime] = useState<Date>(() => {
    const now = new Date();
    now.setSeconds(0, 0);
    return now;
  });

  useEffect(() => {
    const updateTime = () => {
      const now = new Date();
      now.setSeconds(0, 0);
      setTime(now);
    };

    const now = new Date();
    const secondsUntilNextMinute = 60 - now.getSeconds();
    const millisecondsUntilNextMinute =
      secondsUntilNextMinute * 1000 - now.getMilliseconds();

    const firstTimer = setTimeout(() => {
      updateTime();

      const interval = setInterval(updateTime, 60000);

      return () => clearInterval(interval);
    }, millisecondsUntilNextMinute);

    return () => clearTimeout(firstTimer);
  }, []);

  return time;
}
